// extracted by mini-css-extract-plugin
export var bounce = "_j5-1";
export var generatingText = "_j5-6";
export var lightning = "_j5-4";
export var popup = "_j5-5";
export var progressBar = "_j5-7";
export var progressFill = "_j5-8";
export var progressShimmer = "_j5-9";
export var progressText = "_j5-a";
export var shimmer = "_j5-3";
export var uploadIcon = "_j5-0";
export var uploadingText = "_j5-2";